<template>
	<div class="panel-block is-block">
		<div class="columns is-mobile is-vcentered is-gapless actividad-row">
			<div class="column">
				<div class="columns is-vcentered is-mobile is-gapless">
					<div class="column is-narrow"><span class="icon"><font-awesome-icon class="icon" :icon="icon"/></span></div>
					<div class="column"><span class="" v-html="text"></span></div>
				</div>
			</div>
			<div class="column is-narrow botones" v-if="link">
				<button class="button is-small is-block" @click.prevent="btnClicked(link.route)">{{ link.btnText }}</button>
			</div>
		</div>
		<p class="timeago">{{ $timeago.format(new Date(created),'es') }}</p>
	</div>
</template>

<script>
	export default {
		props: {
			icon:{
				type: String,
				required: false
			},
			text:{
				type: String,
				required: true
			},
			button:{
				type: String,
				required: false
			},
			link: {
				type: Object,
				required: false
			},
			created: {
				type: String,
				required: true
			}
		},
		name: 'ActividadRow',

		data() {
			return {

			};
		},
		methods: {
			btnClicked(route){
				//Go to route
				this.$router.push(route)
				//this.$emit('btnClicked');
			}
		}
	};
</script>

<style lang="css" scoped>
.actividad-quinielazo .botones{
	margin-left: 0.5em !important;
}
.actividad-row{
	margin-bottom: .5em !important;
}
.timeago{
	color: #999;
	text-align: right;
	font-size: .8em;
}
</style>
